module.exports = __webpack_public_path__ + "static/media/investor-scout-3-logo-full-white.00d66a06.svg";